import { render, staticRenderFns } from "./interview-record.vue?vue&type=template&id=73f818ec&scoped=true"
import script from "./interview-record.vue?vue&type=script&lang=js"
export * from "./interview-record.vue?vue&type=script&lang=js"
import style0 from "./interview-record.vue?vue&type=style&index=0&id=73f818ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f818ec",
  null
  
)

export default component.exports